import {call} from "redux-saga/effects";
import {apiGet, apiPost, useSagaResult} from "./client";
import {useCallback} from "react";
import {useSagaCallback} from "../store/sagas";

export const useCancelSubscription = (feedbackCh) => {
    return useSagaCallback(feedbackCh, useCallback(function* () {
        const data = yield call(apiPost, `/api/v2/payments/cancel_subscription`, {});
        return data || false;
    }, []));
};

export const useIncreaseSubscriptionPrice = (feedbackCh) => {
    return useSagaCallback(feedbackCh, useCallback(function* (price) {
        const data = yield call(apiPost, `/api/v2/payments/change_subscription?price=${price}`, {});
        return data || false;
    }, []));
};

export function* createSubscriptionRenewal() {
    const data = yield call(apiPost, `/api/v2/payments/renew_subscription`, {});
    return data.payments[0] || false;
}

export const useSubscriptionRenewal = (feedbackCh) =>
    useSagaResult(feedbackCh, useCallback(() => createSubscriptionRenewal(), []));

export function* createCryptoPayment(type, tier, length, awards, subscriptionPrice) {
    const data = yield call(apiPost, `/api/v2/payments/create_cryptocurrency?type=${type}&tier=${tier}&length=${length}&awards=${awards}&subscriptionPrice=${subscriptionPrice}`, {});
    return data.payments[0] || false;
}

export const useCreateCryptoPayment = (feedbackCh, type, tier, length, awards, price) =>
    useSagaResult(feedbackCh, useCallback(() => createCryptoPayment(type, tier, length, awards, price), [type, tier, length, awards, price]));

export function* getPaymentHistory() {
    const data = yield call(apiGet, `/api/v2/payments/history`, {});
    return data.payments || false;
}

export const usePaymentHistory = (feedbackCh) =>
    useSagaResult(feedbackCh, useCallback(() => getPaymentHistory(), []));

export function* getSubscriptionStatus() {
    const data = yield call(apiGet, `/api/v2/payments/subscription`, {});
    return data.subscription || false;
}

export const useSubscriptionStatus = (feedbackCh) =>
    useSagaResult(feedbackCh, useCallback(() => getSubscriptionStatus(), []));

export function* createCardPayment(type, tier, awards, price) {
    const data = yield call(apiPost, `/api/v2/payments/create_card?type=${type}&tier=${tier}&awards=${awards}&price=${price}`, {});
    return data || false;
}

export const useCreateCardPayment = (feedbackCh, type, tier, awards, price) =>
    useSagaResult(feedbackCh, useCallback(() => createCardPayment(type, tier, awards, price), [type, tier, awards, price]));